<template>
    <div :class="Size">&times;</div>
</template>

<script>
export default {
  props: {
    sizeX: {
      type: String,
      default: 'N'
    }
  },
  computed: {
    Size () {
      if (this.sizeX.toUpperCase() === 'P') {
        return 'X_cerrar_P'
      } else {
        return 'X_cerrar'
      }
    }
  }
}
</script>

<style scoped>
.X_cerrar{
  font-family: OpenL;
  font-size: 35px;
  position: absolute;
  right: 10px;
  color:white;
  top: 10px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(1, 117, 163, 0);
}
.X_cerrar:hover{
  /* background-color: rgb(253, 242, 205, 0.2); */
  border: solid 1px rgba(1, 117, 163, 0.4);
}
.X_cerrar_P{
  font-family: OpenL;
  font-size: 25px;
  position: absolute;
  right: 8px;
  color:rgb(255, 255, 254);
  top: 5px;
  width: 25px;
  height: 25px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(1, 117, 163, 0);
}.X_cerrar_P:hover{
  /* background-color: rgb(253, 242, 205, 0.2); */
  /*border: solid 1px rgba(1, 117, 163, 0.4);*/
  font-weight: bolder;
}
</style>
